import { useState } from 'react';
import LoginStep1UserType from './steps/LoginStep1UserType';
import LoginStep2Credentials from './steps/LoginStep2Credentials';
import bgimg from "../../assets/loginSignupBg.png";
import { useLanguage } from "../../context/LanguageContext";
import { Link } from "react-router-dom";

export default function LoginForm() {
  const [currentStep, setCurrentStep] = useState(1);
  const [userType, setUserType] = useState(null);
  const { translate, language } = useLanguage();
  const isRTL = language === "ar";

  const handleSelectUserType = (type) => {
    setUserType(type);
    setCurrentStep(2);
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      if (currentStep === 2) {
        setUserType(null);
      }
    }
  };

  return (
    <main
      dir={isRTL ? "rtl" : "ltr"}
      lang={language}
     style={{ backgroundImage: `url(${bgimg})` }}
      className="min-h-screen bg-cover bg-center  bg-no-repeat flex items-center justify-center p-4"
    >

       
      {/* Login card – using your dark blue from tailwind config */}
      <div className="
        bg-bg-blue
        rounded-xl
        w-full max-w-md
        shadow-2xl shadow-black/30
        p-8
        mx-auto
        transition-all duration-300
        text-white
      ">
        {/* Header */}
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-white mb-2">
            {translate("auth.login.welcomeBack")}
          </h1>
          <p className="text-gray-300">
            {translate("auth.login.signInSubtitle")}
          </p>
        </div>

        {/* Step Indicator – adapted for dark bg */}
        <div className="flex text-center gap-3 mb-8">
          <div className="flex-1">
            <div
              className={`h-1.5 rounded-full transition-colors ${currentStep >= 1 ? 'bg-blue-400' : 'bg-gray-600'
                }`}
            />
            <p className="text-xs font-medium mt-3 text-gray-300">
              {userType
                ? (userType === 'buyer'
                  ? translate("auth.login.buyerTitle")
                  : translate("auth.login.sellerTitle"))
                : (currentStep === 1
                  ? translate("auth.login.selectType")
                  : translate("auth.login.loginStep"))}
            </p>
          </div>
          <div className="flex-1">
            <div
              className={`h-1.5 rounded-full transition-colors ${currentStep >= 2 ? 'bg-blue-400' : 'bg-gray-600'
                }`}
            />
            <p className="text-xs font-medium mt-3 text-gray-300">
              {translate("auth.login.credentials")}
            </p>
          </div>
        </div>

        {/* Content – fixed height container to prevent resize jump */}
        <div className="w-full min-h-[380px] flex flex-col">
          {currentStep === 1 && (
            <LoginStep1UserType onSelectUserType={handleSelectUserType} />
          )}

          {currentStep === 2 && userType && (
            <LoginStep2Credentials
              userType={userType}
              onBack={handleBack}
              onSelectUserType={handleSelectUserType}
            />
          )}
        </div>

        {/* Footer Link */}
        <div className="text-center mt-6">
          <p className="text-gray-300 text-sm">
            {translate("auth.login.noAccount")}{' '}
            <Link
              to="/register"
              className="text-blue-400 font-semibold hover:text-blue-300 hover:underline"
            >
              {translate("auth.login.signUpHere")}
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
}